import { useState, useEffect } from "react"
import { TextField, IconButton, Typography, Grid, Box } from "@mui/material"
import EditIcon from "@mui/icons-material/Edit"
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined"
import CancelIcon from "@mui/icons-material/Cancel"
import useStyles from "./useStyles"

export const EditableField = ({
  label,
  initialValue,
  onSave,
  multiline = false,
}) => {
  const [isEditing, setIsEditing] = useState(false)
  const [value, setValue] = useState(initialValue)
  const classes = useStyles()
  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  const handleSave = () => {
    onSave(value)
    setIsEditing(false)
  }

  const handleCancel = () => {
    setValue(initialValue)
    setIsEditing(false)
  }

  return (
    // <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}>
    <Grid
      sx={{
        flexDirection: isEditing ? "row" : "column",
        alignItems: isEditing ? "center" : "flex-start",
        gap: isEditing ? 2 : 0.5,
        width: "100%",
      }}
    >
      <Grid item sx={{ flexShrink: 0 }}>
        <Typography
          component="span"
          className={classes.fieldLabel}
          // variant="body1"
          sx={{
            fontWeight: "bold",
            // whiteSpace: "nowrap",
            // flexShrink: 0,

            color: "#4B4952",
          }}
        >
          {label}
        </Typography>
      </Grid>
      <Grid item sx={{ width: "100%", flexGrow: 1 }}>
        {isEditing ? (
          <>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                width: "100%",
              }}
            >
              <TextField
                fullWidth
                value={value}
                onChange={(e) => setValue(e.target.value)}
                variant="outlined"
                size="small"
                multiline={multiline}
                rows={multiline ? 3 : 1}
                sx={{ flexGrow: 1 }}
              />
              <IconButton
                onClick={handleSave}
                color="success"
                size="small"
                title="Guardar"
              >
                <CheckOutlinedIcon />
              </IconButton>
              <IconButton
                onClick={handleCancel}
                color="primary"
                size="small"
                title="Cancelar"
              >
                <CancelIcon />
              </IconButton>
            </Box>
          </>
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                width: "80%",
              }}
            >
              <Typography
                component="span"
                className={
                  multiline ? classes.multilineText : classes.truncatedText
                }
                sx={{ color: "#4B4952" }}
              >
                {value || (multiline ? "Sin comentarios" : "Sin definir")}
              </Typography>
              <IconButton
                onClick={() => setIsEditing(true)}
                size="small"
                title="Editar"
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Box>
          </>
        )}
      </Grid>
    </Grid>
  )
}
